var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"background fullscreen"}),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('nuxt'),_vm._v(" "),_c('splash',{attrs:{"visible":_vm.splashVisible}}),_vm._v(" "),_c('cookie-message')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }